import { useUpdateStampOrderMutation } from '../../../store/api/stamp-orders-api'
import { useContext } from 'react'
import { EditableContext } from '../components/table/editable/editable-row'
import Tube from '../../../types/api/tube'
import { useAppDispatch } from '../../../store/store'
import { tubesApi } from '../../../store/api/tubes-api'
import { ConvertRelationFields, EndpointQueryParameters } from '../../../types/strapi/strapi'
import dayjs from 'dayjs'
import StampOrder from '../../../types/api/stamp-order'
import useErrorModal from '../../../hooks/api/use-error-modal'

export const useSaveOrder = () => {
    const [updateStampOrder, updateStampOrderState] = useUpdateStampOrderMutation()
    const form = useContext(EditableContext)
    const dispatch = useAppDispatch()

    useErrorModal(updateStampOrderState, `Не удалось обновить поле.`)

    return async <K extends keyof StampOrder>(
        fieldName: K,
        fieldValue: StampOrder[K],
        record: Tube,
        queryParams: EndpointQueryParameters
    ) => {
        if (!form) return

        if (record.stamps?.[0]?.last_order) {
            const documentId = record.stamps[0].last_order.documentId

            const updateData: Partial<ConvertRelationFields<StampOrder>> = {
                [fieldName]: fieldValue,
            }

            if (fieldName === 'orderStatus') {
                updateData.endDate = fieldValue === 'Завершен' ? dayjs().toISOString() : null
            }

            if (fieldName === 'initiator') {
                updateData.initiator = {
                    set: [fieldValue as string], //замена инициатора
                }
            }

            const res = await updateStampOrder({
                docId: documentId,
                body: { data: updateData },
            })

            if ('data' in res) {
                dispatch(
                    tubesApi.util.updateQueryData('getTubes', queryParams, draftTubes => {
                        const targetTube = draftTubes.data.find(
                            tube =>
                                tube.stamps?.[0]?.last_order?.documentId ===
                                res.data?.data.documentId
                        )

                        if (targetTube?.stamps?.[0]?.last_order && res.data) {
                            targetTube.stamps[0].last_order[fieldName] = res.data.data[fieldName]

                            if (fieldName === 'orderStatus') {
                                targetTube.stamps[0].last_order.endDate = res.data.data.endDate
                            }
                        }
                    })
                )
            }
        }
    }
}
